let store = require("./store");
let actions = require("./actions");
let routes = require("./routes");
let timer = require("./timer");

let NavigationView = require("./view/NavigationView");
let FeedbackView = require("./view/FeedbackView");

let locale = navigator.language.match(/^ja/) ? "ja_jp" : "en_us";
let lang = locale.substr(0, 2);
let messagesUrl = `./json/${lang}.json`;

let logout = function () {
  actions.logout(true).then(function () {
    mc.router.trigger("LOGIN_VIEW");
  });
};

let render = function (view, secure) {
  let user = store.getState().user;

  if (!user && secure === true) {
    logout();
  }

  if (user || secure === false) {
    ReactDOM.render(view, document.getElementById("mc-content"));
  }

  if (user || secure === true) {
    ReactDOM.render(<NavigationView/>, document.getElementById("rc-nav"));
  }

  document.getElementById("mc-feedback").style.visibility = user ? "visible" : "hidden";
};

let onLoadMessages = function (messages) {
  // configure language
  mc.format.setLocale(locale);
  mc.bundle.setLanguage(lang);
  mc.bundle.addMessages(messages);

  // configure XHR
  mc.ajax.base(mc.server.API);
  mc.ajax.headers({
    "X-App-Version": window.APP_REV,
    "X-Device-Id": store.getState().deviceId
  });
  mc.ajax.auth((url) => mc.auth.getCredentials(url, store.getState().user));
  mc.ajax.on("before", () => mc.ui.spin(1));
  mc.ajax.on("after", () => mc.ui.spin(-1));
  mc.ajax.on("fatal", function (status) {
    if (status === 498 || (status === 401 && store.getState().user !== null)) {
      mc.ui.alert(tx("error.timeout"), { onHide: logout });
    }
    else if (status >= 500) {
      mc.ui.blast(tx("error.server"), { level: "error" });
    }
  });

  // configure router
  routes.forEach(function (route) {
    mc.router.on(route.path, route.id, function (params) {
      render(<route.view {...params}/>, route.secure);
    });
  });

  // start router
  mc.router.start("/login", !store.getState().user && !location.hash.match(/resets|api/));

  mc.logger.info(window.APP_REV);

  window.rc = {
    actions,
    store,
    lang,
    ui: {
      feedback: FeedbackView.open
    }
  };
};

mc.ajax.get(messagesUrl).then(function (json) {
  onLoadMessages(mc.ajax.parse(json));
});
